import { Icon } from '@innovationnorway/cl-react';
import React, { useCallback, useEffect, useContext } from 'react';
import './DrawerSideMenu.scss';
import { useLocalStorage } from 'src/hooks/use-local-storage';
import { SideMenuSubpageContext } from '../../constants/Context';
import { SidemenuPaths } from './routes';
import { useTranslation } from 'react-i18next';
import useSiteimprove from 'src/hooks/use-siteimprove';
import { useLocation } from 'react-router-dom';
import { SITEIMPROVE_DECLARATIONS } from 'src/features/tracking/constants';
type Props = {
  minimized?: boolean;
};
const DrawerSideMenu: React.FC<React.PropsWithChildren<Props>> = ({ minimized, children }) => {
  const { setPage, page } = useContext(SideMenuSubpageContext);
  const { t: tOnboarding } = useTranslation('onboarding');
  const [localStorageMinimized, setLocalStorageMinimized] = useLocalStorage<boolean>(
    'drawerSideMenuMinimization',
    minimized || true,
  );
  const siteimprove = useSiteimprove();
  const location = useLocation();
  const closeMenu = useCallback(() => {
    setLocalStorageMinimized(true);
  }, [setLocalStorageMinimized]);
  const openSideMenu = useCallback(
    (e: CustomEventInit<SidemenuPaths>) => {
      if (setPage) setPage(e.detail!);
      setLocalStorageMinimized(false);
    },
    [setLocalStorageMinimized, setPage],
  );
  //TODO https://developer.mozilla.org/en-US/docs/Web/API/Invoker_Commands_API
  //Når dette forhåpentligvis er baseline, så vil dette forenkle sidemenyen betraktelig
  useEffect(() => {
    window.addEventListener('closeSideMenu', closeMenu);
    window.addEventListener('openSideMenu', openSideMenu);
    return () => {
      window.removeEventListener('closeSideMenu', closeMenu);
      window.removeEventListener('openSideMenu', openSideMenu);
    };
  }, [closeMenu, setLocalStorageMinimized, openSideMenu]);
  return (
    <aside className="display--flex padding--0 drawer__wrapper">
      <button
        onClick={() => {
          if (localStorageMinimized) {
            siteimprove?.log(SITEIMPROVE_DECLARATIONS.OPEN_HELP_MENU_DRAWER.id, page, location.pathname);
          }
          setLocalStorageMinimized(!localStorageMinimized);
        }}
        className=" drawer-side-menu__menu--handle"
        aria-label={tOnboarding('sidebar.open')}
      >
        {localStorageMinimized ? (
          <Icon prefix="fasr" iconName="angle-double-left" />
        ) : (
          <Icon prefix="fasr" iconName="angle-double-right" />
        )}

        <Icon prefix="fasr" iconName="question-circle" />
      </button>

      {!localStorageMinimized && (
        <div className="drawer-side-menu__menu stack">
          <>
            {React.Children.toArray(children)?.map((child) =>
              React.cloneElement(child as React.ReactElement<any>, { minimized: localStorageMinimized }),
            )}
          </>
        </div>
      )}
    </aside>
  );
};
export default DrawerSideMenu;
